import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-98729f1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alarmMonitor"
};
import { reactive, ref } from "vue";
import todoList from './components/todoList.vue';
import applyList from "./components/applyList.vue";
import doList from "./components/doList.vue";
export default {
  __name: 'index',
  setup(__props) {
    const state = reactive({
      activeName: "applyList"
    });
    //跳转参数
    let routeParams = ref({
      feelName: '',
      //线路名称
      beginTime: '',
      endTime: '',
      dateRange: [],
      alarmType: ''
    });
    const tabClick = val => {
      // 暂时注释
      // router.push({
      //   query: {
      //     id:'',
      //   },
      // });
      routeParams.value = {
        feelName: '',
        beginTime: '',
        endTime: '',
        dateRange: [],
        alarmType: '',
        alarmStatus: ''
      };
    };
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: state.activeName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.activeName = $event),
        class: "alarmMonitor-tabs",
        onTabClick: tabClick
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "我的待办",
          name: "applyList"
        }, {
          default: _withCtx(() => [state.activeName === 'applyList' ? (_openBlock(), _createBlock(applyList, {
            key: 0,
            routeParams: _unref(routeParams)
          }, null, 8, ["routeParams"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "待办事宜",
          name: "todoList"
        }, {
          default: _withCtx(() => [state.activeName === 'todoList' ? (_openBlock(), _createBlock(todoList, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "已办事宜",
          name: "doList"
        }, {
          default: _withCtx(() => [state.activeName === 'doList' ? (_openBlock(), _createBlock(doList, {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};